import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FormHelperText as MuiHelperText } from "@mui/material";

import { FONT_WEIGHT_SEMI_BOLD } from "../utilities";

const labelCss = css`
  font-weight: var(--form-label-weight, ${FONT_WEIGHT_SEMI_BOLD});
`;

// for when you want something to look like a label
// but it isn't semantically so you just want a div
export const Labelish = styled.div`
  ${labelCss}
`;

export const HelperText = MuiHelperText;

// I wonder if there should be a vertical layout and horizontal layout label style
// where the latter has some margin/padding under it
export const Label = styled.label`
  & + input {
    width: 100%;
  }

  ${labelCss}
`;

export const HeadingLabel = styled.h3`
  ${labelCss};
  color: ${({ theme }) => theme.primaryStrong};
  font-size: ${({ theme }) => theme.fontSize};

  margin: 0 0 15px;
  padding: 0;

  user-select: none;

  &:hover {
    color: ${({ theme }) => theme.generalTextIcon};
  }
`;
